document.addEventListener('teeinblue-event-component-injected', () => {
  setTimeout(() => {
    moveElementAfter('#tib-badges', '.product-form');
  }, 2000);
});
const moveElementAfter = (target, after) => {
  const targetEl = document.querySelector(target);
  const afterEl = document.querySelector(after);
  if (targetEl && afterEl) {
    targetEl.style = "";
    afterEl.after(targetEl);
  }
};